import { getMobietrainApiUrl } from './config';
import { clearMobietrainToken, fetchMobietrainToken } from './token';

export class MobietrainHttpError extends Error {
  status: number;

  constructor(status: number, message: string) {
    super(message);
    this.name = 'MobietrainHttpError';
    this.status = status;
  }
}

export const mobietrainFetch = async <T>(path: string, init: RequestInit = {}): Promise<T> => {
  const token = await fetchMobietrainToken();
  const headers = new Headers(init.headers);
  headers.set('authorization', `Bearer ${token}`);
  if (init.body && !headers.has('content-type')) {
    headers.set('content-type', 'application/json');
  }
  const endpoint = `${getMobietrainApiUrl()}${path.startsWith('/') ? path : `/${path}`}`;
  const res = await fetch(endpoint, { ...init, headers });
  if (res.status === 401) {
    clearMobietrainToken();
    throw new Error('Unauthorized');
  }
  if (!res.ok) {
    throw new MobietrainHttpError(res.status, `Mobietrain REST ${res.status} ${res.statusText}`);
  }
  if (res.status === 204) {
    return undefined as T;
  }
  return (await res.json()) as T;
};
